
const unitTreeData = require('../Data/UnitsUpgradeTree.json')
const xOffset = 300;
const yOffset = 120;

var nodes = [];
var edges = [];
var levelNodeCount = {};

function AddNode(faction, character, unit, level, nodeType)
{
    //Add unit
    nodes.push(FormatNode(faction, character, unit, level, nodeType));

    //Add upgrades
    if(unit.upgrades.length > 0)
    {
        unit.upgrades.forEach(upgrade => {

            //Add node
            AddNode(faction, character, upgrade, level + 1, nodeType);

            //Add edge
            edges.push(FormatEdge(unit.unitType, upgrade.unitType));
        });
    }
    //Fake upgrade node
    else if(level < 4)
    {
        //Add node
        AddNode(faction, character, {unitType: unit.unitType+"_fake", characters: [], upgrades: []}, level + 1, "fake");

        //Add edge
        edges.push(FormatEdge(unit.unitType, unit.unitType+"_fake"));
    }
}

function FormatNode(faction, character, unit, level, nodeType)
{
    levelNodeCount[level] += 1;
    let count = levelNodeCount[level];
    let isAvailable = unit.characters.includes(character);

    return ({
        id: unit.unitType,
        position: { x: (level - 1) * xOffset, y: count - 1 },
        level: level,
        type: nodeType,
        data: { faction: faction, isAvailable: isAvailable, unitType: unit.unitType }
    })
}

function FormatEdge(origin, target)
{
    return ({
        id: origin + "-" + target,
        source: origin,
        target: target
    })
}

function GetParentsAverageY(nodeId)
{
    let nodeY = 0;
    let parentCount = 0;

    edges.forEach((e) => {

            if(e.source === nodeId)
            {
                nodeY += nodes.find((n) => n.id === e.target).position.y;
                parentCount++;
            }
        }
    );

    return nodeY / parentCount;
}

function AdjustNodesSpacing()
{
    nodes.forEach(node => {
        if(node.level === 4)
        {
            node.position.y *= yOffset;
        }
    });

    //Adjust from last to first
    for (let level = 3; level >= 0; level--)
    {
        nodes.forEach(node => {

            if(node.level === level)
            {
                node.position.y = GetParentsAverageY(node.id)
            }
        });
    }
}

function RemoveFakeNodesAndEdges()
{
    nodes = nodes.filter((n) => !n.id.includes("fake"));
    edges = edges.filter((e) => !e.id.includes("fake"));
}

function GetCharacters()
{
    let characters = [];

    //Get units
    unitTreeData.factions.forEach(faction => {
        if(faction.faction !== "nature")
            characters.push(faction.units[0].characters.map( (character) =>
                ({ 'faction': faction.faction, 'character': character })
            ));
    });

    return characters.flat();
}

export default function GetFactionTreeAsFlow(faction, character, nodeType)
{
    nodes = [];
    edges = [];
    levelNodeCount = { 1: 0, 2: 0, 3: 0, 4: 0 };

    //Get units
    var units = unitTreeData.factions.find((f) => f.faction === faction).units;

    //Add nodes
    units.forEach(unit => {

        //Add unit
        AddNode(faction, character, unit, 1, nodeType);
    });

    //Adjust spacing
    AdjustNodesSpacing();

    //Remove fake nodes
    RemoveFakeNodesAndEdges();

    return ({ characters: GetCharacters(), nodes: nodes, edges: edges });
}
